import { jsx } from "react/jsx-runtime";
import SendIcon from "@mui/icons-material/Send";
import { validateTidalLicense } from "../../base/index.js";
function Send(props) {
  return /* @__PURE__ */ jsx(
    SendIcon,
    {
      "data-testid": "Send",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Send",
      "data-tidal-icon-meta": "mail,contact,calendar"
    }
  );
}
Send.tidalIconMeta = {
  categories: "mail,contact,calendar",
  name: "Send"
};
validateTidalLicense();
export {
  Send
};
//# sourceMappingURL=Send.js.map
